'use strict';

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var EventEmitter = require('events');

var Stat = require('./stat');

var defaultOptions = {
  movingAverageIntervals: [60 * 1000, // 1 minute
  5 * 60 * 1000, // 5 minutes
  15 * 60 * 1000 // 15 minutes
  ]
};

var Stats = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Stats, _EventEmitter);

  var _super = _createSuper(Stats);

  function Stats(initialCounters, _options) {
    var _this;

    _classCallCheck(this, Stats);

    _this = _super.call(this);
    var options = Object.assign({}, defaultOptions, _options);

    if (typeof options.computeThrottleTimeout !== 'number') {
      throw new Error('need computeThrottleTimeout');
    }

    if (typeof options.computeThrottleMaxQueueSize !== 'number') {
      throw new Error('need computeThrottleMaxQueueSize');
    }

    _this._initialCounters = initialCounters;
    _this._options = options;
    _this._enabled = _this._options.enabled;
    _this._global = new Stat(initialCounters, options);

    _this._global.on('update', function (stats) {
      return _this.emit('update', stats);
    });

    _this._peers = new Map();
    return _this;
  }

  _createClass(Stats, [{
    key: "enable",
    value: function enable() {
      this._enabled = true;
      this._options.enabled = true;

      this._global.enable();
    }
  }, {
    key: "disable",
    value: function disable() {
      this._enabled = false;
      this._options.enabled = false;

      this._global.disable();
    }
  }, {
    key: "stop",
    value: function stop() {
      this._enabled = false;

      this._global.stop();

      var _iterator = _createForOfIteratorHelper(this._peers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var peerStat = _step.value;
          peerStat[1].stop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "snapshot",
    get: function get() {
      return this._global.snapshot;
    }
  }, {
    key: "movingAverages",
    get: function get() {
      return this._global.movingAverages;
    }
  }, {
    key: "forPeer",
    value: function forPeer(peerId) {
      if (peerId.toB58String) {
        peerId = peerId.toB58String();
      }

      return this._peers.get(peerId);
    }
  }, {
    key: "push",
    value: function push(peer, counter, inc) {
      if (this._enabled) {
        this._global.push(counter, inc);

        if (peer) {
          var peerStats = this._peers.get(peer);

          if (!peerStats) {
            peerStats = new Stat(this._initialCounters, this._options);

            this._peers.set(peer, peerStats);
          }

          peerStats.push(counter, inc);
        }
      }
    }
  }, {
    key: "disconnected",
    value: function disconnected(peer) {
      var peerId = peer.toB58String();

      var peerStats = this._peers.get(peerId);

      if (peerStats) {
        peerStats.stop();

        this._peers.delete(peerId);
      }
    }
  }]);

  return Stats;
}(EventEmitter);

module.exports = Stats;